<template>
  <WithTips icon="bi-x" iconColor="#F40000" :buttonBack="true" :buttonRestart="false" :buttonNext="false">
    <template #title>
      <span v-safe-html="$t('game.preGameModalChecksWrongBrowser.title')"></span>
    </template>
    <template #text>
      <span v-safe-html="$t('game.preGameModalChecksWrongBrowser.text')"></span>
    </template>
    <template #tipsTop>
      <span v-safe-html="$t('game.preGameModalChecksWrongBrowser.tipsTop')"></span>
    </template>
    <template #tipsList>
      <li v-safe-html="$t('game.preGameModalChecksWrongBrowser.tip1')"></li>
      <li v-safe-html="$t('game.preGameModalChecksWrongBrowser.tip2')"></li>
      <li v-safe-html="$t('game.preGameModalChecksWrongBrowser.tip3')"></li>
    </template>
    <template #tipsBottom>
      <span v-safe-html="$t('game.preGameModalChecksWrongBrowser.tipsBottom')"></span>
    </template>
  </WithTips>
</template>

<style lang="scss" scoped></style>

<script setup lang="ts">
import WithTips from "./WithTips.vue";
</script>
